// extracted by mini-css-extract-plugin
module.exports = {"imgCon":"hero_imgCon__2mM3c","captionCon":"hero_captionCon__2KiYd","nextLaunch":"hero_nextLaunch__2AT9R","quote":"hero_quote__3D-zf"};